module.exports = __webpack_public_path__ + "media/images/bg1-c28cf58b99ac339175e0580d1723066d.jpg";